import { Button, Divider, List, Tag, message } from 'antd'
import React, { useState, useEffect, useContext } from 'react'
import Avatar from '../../avatar/avatar';
import { appContext } from '../../../AppContext';
import UpdateTodoModal from './modals/UpdateTodoModal';
import CommentDate from '../../timline/comments/comment-date';
import {useFetch} from '@utils'
import { useHistory } from "react-router-dom";

export default function TodoListOverview() {

    const [listSource, setListSource] = useState([]);
    const [appState] = useContext(appContext);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [selectedTodo, setSelectedTodo] = useState({})

    const [result, setResult] = useState([])
    const [doFetch] = useFetch();
    const history = useHistory();

    function onUpdateClick(todo) {
        setSelectedTodo(todo);
        setShowUpdateModal(true);
    }

    useEffect(() => {
        refresh();
          }, // eslint-disable-next-line
      [appState.storyId])

      function refresh()
      {
          const url = `/api/charactertodo`
          doFetch(url)
          .then((response) => onCharactersLoaded(response.isSuccess, response.result))
  
          function onCharactersLoaded(isSuccess, result) { 
            if(isSuccess) {
              setResult(result);
              return;
            }
            setResult([])
            message.error('Could not get Todos');
          }
      }

    useEffect(() => {
        setListSource(result?.filter(_ => _.isDone === false).map(_ => {
            return (
                    <List.Item>
                        <List.Item.Meta
                            avatar={<Avatar name={_.larper.name} />}
                            title={ <>
                                <Tag color={_.isDone ? 'success' : 'warning'}>{_.isDone ? 'Done' : 'Todo'}</Tag>
                                <CommentDate event={_} /> 
                                <br />
                                {`${_.description}`}    
                            </>}
                        />

                        {`${_.character.larper.name} - ${_.character.name}`}
                        {' '}
                        <Button 
                            size='small' 
                            onClick={() => onUpdateClick(_)}
                        >
                            Update
                        </Button>
                        {' '}
                        <Button 
                            size='small' 
                            onClick={() => window.open(`${appState.ownUrl}/character?id=${_.characterId}`, '_blank')}
                        >
                            View character
                        </Button>        

                    </List.Item>
            )
            }));
      }, // eslint-disable-next-line
      [result])

    if(!appState.isSlOfStory) {
        return null
    }

    return (
        <>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 12,
            }}>
                <Divider orientation="left">Open todo's</Divider>
            </div>
            <List
                itemLayout="horizontal"
                dataSource={listSource}
                renderItem={item =>
                item
                }
            /> 

            {showUpdateModal && <UpdateTodoModal 
                setIsModalVisible={setShowUpdateModal}
                isModalVisible={showUpdateModal}
                record={selectedTodo}
                refresh={refresh}
            />}
        </>
    )
}